import axios from 'axios';
import EnvironmentManager from 'Utils/environmentManager';

import errorMessage from './errorMessage';
import {
  GET_HELP_MENU_ITEMS_REQUEST,
  GET_HELP_MENU_ITEMS_SUCCESS,
  GET_HELP_MENU_ITEMS_FAILURE,
  GET_HELP_MENU_DETAILS_REQUEST,
  GET_HELP_MENU_DETAILS_SUCCESS,
  GET_HELP_MENU_SUCCESS,
  GET_HELP_MENU_DETAILS_FAILURE,
  GET_DEPOSIT_MENU_REQUEST,
  GET_DEPOSIT_MENU_SUCCESS,
  GET_DEPOSIT_MENU_FAILURE,
  GET_CMS_UPDATER_REQUEST,
  GET_CMS_UPDATER_SUCCESS,
  GET_CMS_UPDATER_FAILURE
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getHelpMenuItems = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_HELP_MENU_ITEMS_REQUEST
    });

    let res = await axios.get(API_GATEWAY + '/cms/content/help-menu-categories');

    dispatch({
      type: GET_HELP_MENU_ITEMS_SUCCESS,
      payload: res.data?.helpTopicCategories
    });

  } catch (err) {
    dispatch({
      type: GET_HELP_MENU_ITEMS_FAILURE,
      payload: errorMessage
    });
  }
};

export const getHelpMenu = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_HELP_MENU_DETAILS_REQUEST
    });

    let res = await axios.get(`${API_GATEWAY}/cms/content/help-menu`);
    
    const helpTopics = res.data.helpTopics;
    let menuDetails = {};
    
    helpTopics.forEach(topic=> {
      menuDetails = {
        ...menuDetails,
        [topic.slug]: topic
      };
    });

    dispatch({
      type: GET_HELP_MENU_SUCCESS,
      payload: { helpTopics, menuDetails }
    });


  } catch (err) {
    dispatch({
      type: GET_HELP_MENU_DETAILS_FAILURE,
      payload: errorMessage
    });
  }
};

export const getHelpMenuDetails = categoryName => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_HELP_MENU_DETAILS_REQUEST
    });

    const details = getState().cms.helpMenu.details;

    if (!details[categoryName]) {
      let res = await axios.get(`${API_GATEWAY}/cms/content/help-menu?slug=${categoryName}`);

      dispatch({
        type: GET_HELP_MENU_DETAILS_SUCCESS,
        payload: { data: res.data.helpTopics[0], categoryName }
      });
    }

  } catch (err) {
    dispatch({
      type: GET_HELP_MENU_DETAILS_FAILURE,
      payload: errorMessage
    });
  }
};

export const getDepositMenu = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_DEPOSIT_MENU_REQUEST
    });

    let res = await axios.get(`${API_GATEWAY}/cms/content/bank-info`);

    dispatch({
      type: GET_DEPOSIT_MENU_SUCCESS,
      payload: res.data
    });

  } catch (err) {
    dispatch({
      type: GET_DEPOSIT_MENU_FAILURE,
      payload: errorMessage
    });
  }
};


export const cmsUpdater = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_CMS_UPDATER_REQUEST
    });
    const reloadedRows = await EnvironmentManager.checkPageReload();
    await Promise.all([
      EnvironmentManager._getParameters(reloadedRows),
      EnvironmentManager._getTjkCms()
    ]);

    dispatch({
      type: GET_CMS_UPDATER_SUCCESS,
      payload: true
    });
  } catch (err) {
    dispatch({
      type: GET_CMS_UPDATER_FAILURE,
      payload: false
    });
  }
};
